import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetalingsregelingAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M28.84 26.32c-.59.59-1.54.59-2.12 0 .59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0 .59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0 .59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0l-.68-.68-8.86-8.86-1-3.02c-.26-.79-.71-1.52-1.3-2.11l-1.24-1.24 5.66-5.66 1.23 1.23c.59.59 1.31 1.03 2.09 1.29l3.04 1.01 8.84 8.84.35.35.35.35c.59.59.59 1.54 0 2.12z"
    />
    <path
      fill="#B3E9B1"
      d="m3.03 13.95 6.36-6.36.71-.71 3.54 3.54-7.07 7.07zm14.5 15.2.35-.35c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l.53-.53c.49-.49.41-1.36-.18-1.94s-1.46-.66-1.94-.18l-.88.88c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-.71.71a1.49 1.49 0 0 0 0 2.12c.59.59 1.54.59 2.12 0l-.18.18c-.49.49-.41 1.36.18 1.94.59.59 1.46.66 1.94.18l.18-.18a1.49 1.49 0 0 0 0 2.12c.59.59 1.54.59 2.12 0a1.49 1.49 0 0 0 0 2.12c.59.59 1.54.59 2.12 0l.71-.71c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0M29.2 9l-2.68 2.68c-.56.56-1.26.94-2.04 1.09l-2.9-.15c-1-.05-1.98.32-2.69 1.03l-3.48 3.48-.35.35-.35.35a1.49 1.49 0 0 0 0 2.12c.59.58 1.54.59 2.12 0l.35-.35 1.7-1.7c.26-.26.65-.35 1-.24l3.34 1.11q.33.105.57.36l4.7 4.7 1.78-1.78c.23-.23.38-.51.44-.82l.37-1.87c.15-.77.53-1.48 1.09-2.04l2.68-2.68-5.66-5.66z"
    />
    <path
      fill="#60D15D"
      d="m26.36 10.41 7.08 7.07 3.53-3.53-.71-.71-6.36-6.36z"
    />
    <path
      fill="#00215B"
      d="M14.143 9.151 7.644 15.65l.707.707 6.499-6.498zM22.18 18.73c-.71 0-1.44-.16-2.14-.47l.41-.91c1.26.57 2.69.49 3.65-.21.72-.52 1.06-1.3.96-2.18l.99-.11c.14 1.24-.36 2.37-1.37 3.1-.71.52-1.6.78-2.52.78z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetalingsregelingAanvragen);

export default ForwardRef;
